import React, { useState } from 'react';
import './Blog.css';
import ScrollSection from '../../components/ScrollSection';
import { useContent } from '../../context/ContentContext';

const Blog = () => {
  const { content, loading } = useContent();
  const [expanded, setExpanded] = useState(null);

  if (loading || !content) return null;

  const toggle = (id) => setExpanded(expanded === id ? null : id);

  return (
    <ScrollSection name="blog">
      <div className="section-container">
        <h2 className="section-title" data-aos="fade-up" data-aos-duration="800">Engineering Blog</h2>
        <p className="blog-subtitle" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
          Incident reviews and lessons learned from real systems.
        </p>
        <div className="blog-scroll-container" data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
          {[...content.blog].sort((a, b) => {
            if (!a.date && !b.date) return 0;
            if (!a.date) return 1;
            if (!b.date) return -1;
            return new Date(b.date) - new Date(a.date);
          }).map((post, index) => (
            <article key={post.id} className="blog-card">
              <div className="blog-card-header">
                <span className="blog-tag">{post.tag}</span>
                <span className="blog-date">{post.date}</span>
              </div>
              <h3 className="blog-card-title">{post.title}</h3>
              <p className="blog-summary">{post.summary}</p>
              <button className="blog-toggle-btn" onClick={() => toggle(post.id)}>
                {expanded === post.id ? 'Collapse' : 'Read breakdown'}
              </button>
              {expanded === post.id && (
                <div className="blog-details">
                  <ul>
                    {post.details.map((detail, index) => (
                      <li key={index}>{detail}</li>
                    ))}
                  </ul>
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </ScrollSection>
  );
};

export default Blog;
